export const BreakpointsSearchPageDefaultEnum = {
  MobileXS: 350,
  MobileS: 475,
  XXS: 768,
  XS: 768,
  S: 992,
  M: 1200,
  L: 1440,
  XL: 1920,
}

export const BreakpointsSearchPageTopResultEnum = {
  MobileXS: 350,
  MobileS: 475,
  XXS: 768,
  XS: 768,
  S: 992,
  M: 992,
  L: 1200,
  XL: 1920,
}
